module.exports = __webpack_public_path__ + "static/share-b8baaf500c3f37a05d7545198fe0f1c9.jpg";